// PC端 新接口
const PC_BASE_URL = '/api'
const NODE_DOWNLOAD_BASE_URL = '/puppeteer'
const apiListPC = {
    // 获取客户的行业模块
    getIndustryModule: PC_BASE_URL + '/w/survey/getIndustryModule',
    // 新增协同报告
    addSurvey: PC_BASE_URL + '/w/survey/addSurvey',
    // 通过报告 id  获取该报告的模块信息   分享页面 接口
    getModuleBySurveyId: PC_BASE_URL + '/w/survey/getModuleBySurveyId',
    // 向生成的报告中添加选中大模块
    addModuleToSurvey: PC_BASE_URL + '/w/survey/addModuleToSurvey',
    // 获取答题解释
    getAll: PC_BASE_URL + '/w/survey/getAll',
    // 获取模块下的第一题
    getInitQuestion: PC_BASE_URL + '/w/survey/getInitQuestion',
    // 根据选项获取下一个问题
    getNextQuestions: PC_BASE_URL + '/w/survey/getNextQuestions/',
    // 获取答题进度接口
    getAnswerProgress: PC_BASE_URL + '/w/survey/getAnswerProgress',
    // 获取上一个问题
    getPreviousQuestions: PC_BASE_URL + '/w/survey/getPreviousQuestions/',
    // 提交问卷
    submitSurvey: PC_BASE_URL + '/w/survey/submit',
    // 获取风险信息 (查看报告详情)
    getSurveyRiskInfos: PC_BASE_URL + '/w/survey/getSurveyRiskInfos',
    // 获取企业列表
    getcomList: PC_BASE_URL + '/w/personnalcenter/listEnterprise',
    // 获取问卷下左侧模块列表
    getTopModule: PC_BASE_URL + '/w/survey/getTopModule',

    // 删除企业
    delCom: PC_BASE_URL + '/w/personnalcenter/deleteEnterprise',
    // 编辑企业
    editCom: PC_BASE_URL + '/w/personnalcenter/updateEnterprise',
    // 新增企业
    addEnterprise: PC_BASE_URL + '/w/personnalcenter/addEnterprise',
    // 二次检查企业
    doubleCheck: PC_BASE_URL + '/w/enterprise/checkEnterprise',
    // 我的报告列表接口
    listSurvey: PC_BASE_URL + '/w/personnalcenter/listSurvey',
    // 删除报告接口
    deleteSurvey: PC_BASE_URL + '/w/personnalcenter/deleteSurvey',
    // 我的报告入口点击继续答题获取答题进度接口
    getTeamWorkModuleFromReport: PC_BASE_URL + '/w/personnalcenter/getTeamWorkModuleFromReport',
    // 登录
    login: PC_BASE_URL + '/user/login',
    // 注册
    register: PC_BASE_URL + '/registered',
    // 注册短信验证码
    getRegisterCaptcha: PC_BASE_URL + '/getRegisterCaptcha',
    // 重置密码短信验证码
    getResetCaptcha: PC_BASE_URL + '/getResetCaptcha',
    // 重置密码
    resetPassword: PC_BASE_URL + '/resetPassword',
    // 修改密码
    modifyPassword: PC_BASE_URL + '/w/personnalcenter/modifyPassword',
    // 获取涉诉信息
    getSurveyLawsuits: PC_BASE_URL + '/w/enterprise/getSurveyLawsuitsNew',
    // 获取失信人员名单
    getDishonestExecutors: PC_BASE_URL + '/w/enterprise/getDishonestExecutors',

    // 小程序登录所需要的接口
    // 获取登录用户信息
    getUserInfo: PC_BASE_URL + '/f/user/info',
    // 获取登录用户信息
    getQrCode: PC_BASE_URL + '/wechat/login/code',
    // 微信绑定手机号注册
    WeChatSMSRegistr: PC_BASE_URL + '/wechat/login/register',
    // 微信获取多多手机号列表
    getLoginList: PC_BASE_URL + '/wechat/login/getLoginList',
    // 微信选择手机号登录
    selectToLogin: PC_BASE_URL + '/wechat/login/selectToLogin',
    // 获取客户端信息
    getClientele: PC_BASE_URL + '/clientele/getClientele',

    // 把手3.0微信扫码接口
    signin: PC_BASE_URL + '/compass-front/signin/wechat/connect/signin',

    // node下载pdf
    // downPdf: NODE_DOWNLOAD_BASE_URL + '/exportPdf/pandaTerminal',

    // 申请解禁
    relieveIp: PC_BASE_URL + '/ip/relieve',
    getIpLocation: PC_BASE_URL + '/m/clientent/ip',
    getTime: PC_BASE_URL + '/w/survey/getNeedTimeByModuleIds',
    getLock: PC_BASE_URL + '/c/limit',
    // 下载pdf
    downloadPdf: PC_BASE_URL + '/downloadPdf',
    getEnable: PC_BASE_URL + '/c/limit/enable',

    // 获取案例详情
    getCaseDetail: PC_BASE_URL + '/c/instrument/getInstrumentById',
}
export { apiListPC }
